import React, { useState, useEffect } from 'react';
import { LottieWrapper } from './index';
import Error from '../assets/suspend/error.json';
import '../components/styles/ackBg.css';
import PinkAckErrJSON from '../assets/fibo/ack-fibo-error.json';
import withDashboardMenuLayout from './layout/withDashboardMenuLayout';
import BgPinkScreenDesktop from '../assets/ack-screen-bg/pink-bg-ack-screen.svg';
import BgPinkScreenMobile from '../assets/mobile-ack-screen-bg/mobile-pink-bg-ack-screen.svg';

const InactiveCustomerPage = () => {
  const [statusObj, setStatusObj] = useState({
    statusCode: 0,
    statusMsg: 'There is some technical issue',
    statusDes: 'Something went wrong, Please try again later',
  });
  const [AckBackgroundSrc, setAckBackgroundSrc] = useState('');
  const [CTAButtonText, setCTAButtonText] = useState('Re-login');
  const [secondaryCTAText, setSecondaryCTAText] = useState('');

  const secondaryCTATextClickHandler = () => {
    let statusCode = statusObj.statusCode;
    if (statusCode === 1064) {
      window.location.href = `${window.location.origin}/dashboard`;
    }
  };

  const redirectToHome = () => {
    localStorage.clear();
    window.location.href = `${window.location.origin}/SignUp`;
  };

  const ctaButtonClickHandler = () => {
    let statusCode = statusObj.statusCode;

    if (statusCode === 503 || statusCode === 0 || statusCode === 1064) {
      window.location.href = `${window.location.origin}/SignUp`;
      return;
    }

    if (statusCode >= 3000 && statusCode < 4000) {
      localStorage.clear();
      window.location.href = `${window.location.origin}/SignUp`;
    } else if (statusCode >= 4000 && statusCode < 5000) {
      // DOCS: Move to dashboard
      window.location.href = `${window.location.origin}/dashboard`;
    }
  };

  useEffect(() => {
    // DOCS: rehydrate the state from local storage
    const inactiveCustomerError = localStorage.getItem('inactiveCustomerError');
    console.log('inactiveCustomerError: ', inactiveCustomerError);

    // DOCS: rehydrate the state from local storage
    const disasterRecoveryState = localStorage.getItem('disasterRecoveryState');
    console.log('disasterRecoveryState: ', disasterRecoveryState);

    // DOCS: rehydrate the state from local storage
    const duplicatePan = localStorage.getItem('duplicatePan');
    console.log('duplicatePan State: ', duplicatePan);

    setAckBackgroundSrc(
      window.innerWidth > 768 ? BgPinkScreenDesktop : BgPinkScreenMobile
    );
    if (inactiveCustomerError) {
      const inactiveCustomerErrorObj = JSON.parse(inactiveCustomerError);
      setStatusObj({ ...JSON.parse(inactiveCustomerErrorObj) });
      let statusCode = inactiveCustomerErrorObj?.statusCode;
      if (statusCode >= 3000 && statusCode < 4000) {
        // DOCS: Relogin this type of customer
        setCTAButtonText('Re-login');
      } else if (statusCode >= 4000 && statusCode < 5000) {
        // DOCS: send this type of customer to dashboard
        setCTAButtonText('Okay got it');
      }
    } else if (disasterRecoveryState) {
      setStatusObj({ ...JSON.parse(disasterRecoveryState) });
      setCTAButtonText('Okay got it');
    } else if (duplicatePan) {
      const obj = JSON.parse(duplicatePan);
      setStatusObj({ ...obj });
      setCTAButtonText(obj.primaryCta);
      setSecondaryCTAText(obj.secondaryCta);
    }
  }, []);

  const { statusMsg, statusDes } = statusObj;
  return (
    <>
      {AckBackgroundSrc ? (
        <div className="relative flex justify-center items-center">
          <img
            className="mobile:max-h-[100vh] md:max-h-[85vh] absolute object-cover left-0 right-0 top-0 z-[0] w-full "
            src={AckBackgroundSrc}
          />
        </div>
      ) : (
        ''
      )}
      <div className={`h-screen lg:!h-[85vh] mobile:w-full `}>
        <div className="absolute p-6 bottom-4 flex flex-col">
          <LottieWrapper animationData={Error} width="250px" height="250px" />
          <span className="mt-5 font-headline font-bold text-[28px]">
            {statusMsg || `There is some technical issue`}
          </span>
          <span className="font-headline mt-3 font-semibold text-base text-text-secondary">
            {statusDes || `Something went wrong, Please try again later`}
          </span>
          {CTAButtonText ? (
            <button
              type="button"
              onClick={ctaButtonClickHandler}
              className="w-[350px] mobile:w-full py-3 bg-accent text-white rounded-md shadow-lg font-headline mt-4 font-semibold text-base"
            >
              {CTAButtonText}
            </button>
          ) : (
            ''
          )}
          {secondaryCTAText ? (
            <button
              className={`mobile:mx-auto mobile:my-1 max-w-sm w-80 mt-1 text-cyan-500 background-transparent font-bold mobile:px-0 px-6 py-2 text-sm outline-none focus:outline-none  mb-1 ease-linear transition-all duration-150`}
              type="button"
              style={{ color: '#079F9F' }}
              onClick={secondaryCTATextClickHandler}
            >
              {secondaryCTAText}
            </button>
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  );
};

export default InactiveCustomerPage;
